module.exports = __webpack_public_path__ + "img/1.5ce2bb48.png";